var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "clubList" } } }, [
            _vm._v(_vm._s(_vm.$t("entities.player.plural")) + " ")
          ]),
          _vm._v(" "),
          _vm.model
            ? _c(
                "el-breadcrumb-item",
                {
                  attrs: {
                    to: { name: "clubShow", params: { id: _vm.model.id } }
                  }
                },
                [_vm._v(_vm._s(_vm.model.name))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.player.singular")) + " history")
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "search",
          attrs: { inline: true },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: _vm.$t("table.search") },
                  model: {
                    value: _vm.pager.search,
                    callback: function($$v) {
                      _vm.$set(_vm.pager, "search", $$v)
                    },
                    expression: "pager.search"
                  }
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    slot: "append"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "modified",
              order: "descending"
            },
            "empty-text": "There is no history yet",
            border: ""
          },
          on: {
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "modified",
              label: "Updated at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.modified)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Updated by",
              prop: "modifiedBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "created",
              label: "Created at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.created)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Created by",
              prop: "createdBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "deleted",
              label: "Deleted at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.deleted)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Deleted by",
              prop: "deletedBy.email",
              sortable: "custom"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd69d6f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd69d6f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/club/club-history/club-history-single/club-history-single.vue
// module id = null
// module chunks = 